import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./ManufacturerGroupReportSummary.module.css";

const ManufacturerGroupReportSummary = ({
  showAutoComplete = () => {},
  refreshData = () => {},
  refreshRef,
}) => {
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              label="Add New Manufacturer Group"
              color="violet"
              onClick={showAutoComplete}
              endIcon={<Shortcut keys={["Alt", "G"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default ManufacturerGroupReportSummary;
